import React from "react"

function Readout(props) {
    const styles = {
        background: "none",
        margin: 0,
        textAlign: "left"
    }
    
    if (props.phaseComplete) {
        styles.background = "green"
        styles.margin = "auto"
        styles.textAlign = "center"
    } else if (props.codeSubmitted && !props.phaseComplete) {
        styles.background = "red"
    }
    
    return (
        <h1 style={styles}>{props.output}</h1>
    )
}

export default Readout